import React from 'react'
import { Box, Paper, Skeleton, Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ApiTableSkeleton } from '@e3dc-react/shell/Elements/Skeletons'

const useStyles = makeStyles()(theme => ({
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  cardSkeleton: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
  },
  filterSkeleton: {
    borderRadius: theme.spacing(theme.shape.borderRadius),
    height: 36,
    width: 100,
  },
}))

export const EMobilityChargingSessionsSkeleton = (): React.ReactElement => {
  const { classes, cx } = useStyles()

  return (
    <Box>
      <Stack direction="row" justifyContent={'space-between'} alignItems={'center'} mb={2}>
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
          <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
        </Stack>
        <Skeleton variant="rounded" className={cx(classes.cardSkeleton, classes.filterSkeleton)} />
      </Stack>

      <Box className={classes.tableContainer} sx={{ pt: 2 }}>
        <Paper>
          <ApiTableSkeleton columnAmount={6} withFilter={false} />
        </Paper>
      </Box>
    </Box>
  )
}
